import http from '../http'
import { storageUtil } from '@/utils'

const { getLocalStorage } = storageUtil

export default {
  // paifa商城注册
  getPaifaCorpSetting(data: object, option: object = {}) {
    return http.post('/corp/pai_fa/web_conf', data, option)
  },
  // 查询首页模块
  queryHomeModule(data: object, option: object = {}) {
    return http.post('/corp/cloud_store/query_corp_module', data, option)
  },
  // 查询首页模块详情
  queryHomeModuleDetail(data: object, option: object = {}) {
    const corpInfo = getLocalStorage('corpInfo', true) || {}
    const { industryId } = corpInfo

    return http.post(
      '/corp/cloud_store/query_corp_module_detail',
      { ...data, industryId },
      option,
    )
  },
  // 查询企业云店基本信息
  getCloudStorePersonalInfo(data: object, option: object = {}) {
    return http.post(
      '/corp/setting/get_cloud_store_personal_info',
      data,
      option,
    )
  },
}
